import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useAuth } from "../lib/auth";
import { ArrowRight } from "@phosphor-icons/react";

const ROLES = [
  { v: "expert", l: "Expert" },
  { v: "researcher", l: "Researcher" },
  { v: "innovator", l: "Innovator" },
  { v: "public", l: "Public" },
];

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "expert" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await register(form);
    setBusy(false);
    if (res.ok) nav("/feed");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-[#0A0A0C]" data-testid="register-page">
      <div className="hidden md:flex flex-col justify-between p-10 blueprint-grid border-r border-[#27272A]">
        <Link to="/"><Logo size={30} /></Link>
        <div>
          <div className="label-mono mb-4" style={{ color: "#E60012" }}>SESSION · NEW</div>
          <h1 className="font-display text-white" style={{ fontSize: 56, fontWeight: 900, letterSpacing: "-0.035em", lineHeight: 0.95 }}>
            Reserve your<br />handle.
          </h1>
          <p className="text-zinc-400 mt-6 max-w-md">
            Tell us what you bring to the convoy. Expert, researcher, innovator, or curious public — every signal counts.
          </p>
        </div>
        <div className="label-mono">IAAM/AUTH/002</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
          <Link to="/" className="md:hidden mb-8 inline-block"><Logo size={26} /></Link>
          <div className="label-mono mb-2">CREATE ACCOUNT</div>
          <h2 className="font-display text-white mb-8" style={{ fontSize: 32, fontWeight: 900, letterSpacing: "-0.03em" }}>
            Join iAAM
          </h2>

          <label className="label-mono block mb-1.5">Display name</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            required className="input mb-4" placeholder="e.g. Yuki Tanaka" data-testid="register-name-input" />

          <label className="label-mono block mb-1.5">Email</label>
          <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            required className="input mb-4" placeholder="you@aerospace.io" data-testid="register-email-input" />

          <label className="label-mono block mb-1.5">Password (min 6)</label>
          <input type="password" minLength={6} value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required className="input mb-4" placeholder="••••••••" data-testid="register-password-input" />

          <label className="label-mono block mb-1.5">Your role</label>
          <div className="grid grid-cols-4 gap-2 mb-6">
            {ROLES.map((r) => (
              <button type="button" key={r.v}
                onClick={() => setForm({ ...form, role: r.v })}
                className={`py-2 text-xs font-mono uppercase tracking-wider border transition-colors ${
                  form.role === r.v
                    ? "bg-[#E60012] border-[#E60012] text-white"
                    : "border-[#27272A] text-zinc-400 hover:border-zinc-500"
                }`}
                data-testid={`register-role-${r.v}`}
              >
                {r.l}
              </button>
            ))}
          </div>

          {error && (
            <div className="mb-4 text-sm text-red-500 border border-red-900/50 bg-red-950/30 px-3 py-2" data-testid="register-error">
              {error}
            </div>
          )}

          <button type="submit" disabled={busy} className="btn btn-primary w-full" data-testid="register-submit-btn">
            {busy ? <span className="spinner" /> : <>Create account <ArrowRight size={14} weight="bold" /></>}
          </button>

          <p className="text-sm text-zinc-400 mt-6 text-center">
            Already a member?{" "}
            <Link to="/login" className="text-white underline-offset-4 hover:underline" data-testid="register-to-login-link">
              Sign in
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
